import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'
import { DataGrid } from '../../../../components/data-grid'
import {
  RecognitionChannelsDocument,
  RecognitionChannelsQuery,
} from '../../../../generated/graphql'
import { Container } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ArrayElement } from '../../../../utils/types'
import { useNavigate } from 'react-router'
import { useAbsolutePath } from '../../../../hooks/absolute-path'
import { RootRoute } from '../../..'
import { PageHeader } from '../../../../components/page-header'

type Row = ArrayElement<
  NonNullable<RecognitionChannelsQuery['settings']['crm']>['channels']
>

export const SettingsReconitionsPage = () => {
  const { t } = useTranslation(['apps', 'shared'])
  const navigate = useNavigate()
  const generatePath = useAbsolutePath()

  const { data } = useQuery(RecognitionChannelsDocument)

  const channels = data?.settings.crm?.channels || []

  const columns = useMemo<GridColDef<Row>[]>(
    () => [
      {
        field: 'id',
        minWidth: 280,
        headerName: t('apps:recognition.id_column'),
      },
    ],
    [t],
  )

  return (
    <>
      <PageHeader title={t('shared:menu.recognition')} isSticky />
      <Container>
        <DataGrid
          name="channels"
          rows={channels}
          columns={columns}
          rowHeight={51}
          rowCount={channels.length}
          disableAllFilters
          hideFooter
          onRowClick={(row) => {
            void navigate(
              generatePath(RootRoute.AppsRecognition, { id: row.id }),
            )
          }}
        />
      </Container>
    </>
  )
}
